import React from 'react'
import EmailNotificationContainer from '../../containers/admin_portal/email_notification';
const EmailNotificationPage = () => {
    return (
        <div>
            <EmailNotificationContainer />
        </div>
    )
}
export default EmailNotificationPage;
